import { bind } from 'decko';
import { css } from 'emotion';
import { observer } from 'mobx-react';
import * as React from 'react';

import checked from '../assets/onSelectedColor/checked.svg';
import itemShadow from '../assets/onSelectedColor/itemShadow.svg';
import { BREAKPOINT_SMALL } from '../consts/breakpoints';

// #region Style
const container = css`
  width: 60px;
  height: 60px;
  padding-top: 4px;
  cursor: pointer;
  @media (min-width: ${BREAKPOINT_SMALL}) {
    width: 60px;
    height: 60px;
  }
`;

const colorContainer = css`
  width: 50px;
  height: 33px;
  display: flex;
  margin: 12px 0px 0px 12px;
  @media (min-width: ${BREAKPOINT_SMALL}) {
    width: 50px;
    height: 36px;
  }
`;
// #endregion

interface IColorItemProps {
  color?: string;
  isSelected?: boolean;
  onClick?(value?: string): void;
}

@observer
export class ColorItem extends React.Component<IColorItemProps> {
  public static defaultProps = {
    isSelected: false,
  };

  public render() {
    const { color, isSelected } = this.props;

    return (
      <div className={container} onClick={this.onClick()} role="listbox">
        <div className={colorContainer}>
          <div className={this.computeColoredCircleStyle(color, isSelected)} />
          <div className={this.computeCheckedIconStyle(isSelected)} />
        </div>
        <div className={this.computeShadowStyle(isSelected)} />
      </div>
    );
  }

  @bind
  private onClick() {
    const { onClick, color } = this.props;

    return () => onClick && onClick(color);
  }

  private computeColoredCircleStyle(color?: string, isSelected?: boolean) {
    const sizeMobile = isSelected ? '27px' : '30px';
    const sizeDesktop = isSelected ? '30px' : '36px';

    return css`
      width: ${sizeMobile};
      height: ${sizeMobile};
      margin-right: 2px;
      object-fit: contain;
      border-radius: 20px;
      background-color: ${color};
      @media (min-width: ${BREAKPOINT_SMALL}) {
        width: ${sizeDesktop};
        height: ${sizeDesktop};
      }
    `;
  }

  private computeCheckedIconStyle(isSelected?: boolean) {
    const display = isSelected ? 'block' : 'none';

    return css`
      width: 9px;
      height: 9px;
      background-image: ${`url(${checked})`};
      display: ${display};
    `;
  }

  private computeShadowStyle(isSelected?: boolean) {
    const display = isSelected ? 'block' : 'none';

    return css`
      width: 32px;
      height: 6px;
      margin-left: 10px;
      background-image: ${`url(${itemShadow})`};
      display: ${display};
      @media (min-width: ${BREAKPOINT_SMALL}) {
        margin-left: 12px;
      }
    `;
  }
}
